import { useDownloadMutation } from '~/hooks/common';
import { axiosInstance, downloadBlobDataFile } from '~/services';

import { API_ENDPOINT } from '~/constants';

import type { TypeReturnDisposalListDownloadParams } from '~/types/receive.types';

/**
 * [입고관리 > 회송/폐기 관리] 목록 엑셀 다운로드 API
 * @note 현재 필터 기준 전체 다운로드(limit/offset 없음). 공통 헤더는 게이트웨이 자동 주입.
 *       파일명은 BE의 Content-Disposition을 그대로 사용한다.
 */
const fetchReturnDisposalListDownload = async (params: TypeReturnDisposalListDownloadParams): Promise<void> => {
  const response = await axiosInstance.get(API_ENDPOINT.RECEIVE.GET_RETURN_DISPOSAL_ISSUES_DOWNLOAD, {
    params,
    responseType: 'blob',
  });

  await downloadBlobDataFile(response);
};

/** [입고관리 > 회송/폐기 관리] 목록 엑셀 다운로드 Mutation Hook */
export const useGetReturnDisposalListDownloadMutation = () => {
  return useDownloadMutation(fetchReturnDisposalListDownload);
};
